import React, { useEffect, useRef, useState } from 'react';
import * as BABYLON from '@babylonjs/core';
import '@babylonjs/loaders/glTF';
import './CockFight3D.css';
import Coin from './Coin';
import { useAuthStore } from '../stores/authStore';

const CockFight3D = ({ gameState, myBet, onCockWin }) => {
  const { user } = useAuthStore();
  const canvasRef = useRef(null);
  const engineRef = useRef(null);
  const sceneRef = useRef(null);
  const cock1Ref = useRef(null);
  const cock2Ref = useRef(null);
  const shadowGenRef = useRef(null);

  // Refs to keep latest booleans inside the render loop
  const isAttacking1Ref = useRef(false);
  const isAttacking2Ref = useRef(false);
  const isDefending1Ref = useRef(false);
  const isDefending2Ref = useRef(false);

  const [cock1Health, setCock1Health] = useState(100);
  const [cock2Health, setCock2Health] = useState(100);
  const [winner, setWinner] = useState(null);
  const [isAttacking1, setIsAttacking1] = useState(false);
  const [isAttacking2, setIsAttacking2] = useState(false);
  const [isDefending1, setIsDefending1] = useState(false);
  const [isDefending2, setIsDefending2] = useState(false);


  // Mirror states into refs so the Babylon render loop always reads the latest values
  useEffect(() => { isAttacking1Ref.current = isAttacking1; }, [isAttacking1]);
  useEffect(() => { isAttacking2Ref.current = isAttacking2; }, [isAttacking2]);
  useEffect(() => { isDefending1Ref.current = isDefending1; }, [isDefending1]);
  useEffect(() => { isDefending2Ref.current = isDefending2; }, [isDefending2]);

  useEffect(() => {
    if (!canvasRef.current) return;

    const engine = new BABYLON.Engine(canvasRef.current, true, { preserveDrawingBuffer: true, stencil: true });
    engineRef.current = engine;

    const scene = new BABYLON.Scene(engine);
    sceneRef.current = scene;
    scene.clearColor = new BABYLON.Color4(0.102, 0.102, 0.102, 1); // ~ 0x1a1a1a

    // Camera - Positioned for better view of the fighting area
    const camera = new BABYLON.FreeCamera('camera', new BABYLON.Vector3(0, 8, 20), scene);
    camera.setTarget(new BABYLON.Vector3(0, 2, 0));
    camera.minZ = 0.1;
    camera.maxZ = 1000;
    // We don't attach controls to keep the fixed cinematic view

    // Lights - Enhanced lighting for better visibility
    const hemi = new BABYLON.HemisphericLight('hemilight', new BABYLON.Vector3(0, 1, 0), scene);
    hemi.intensity = 0.3; // Increased ambient light

    const dir = new BABYLON.DirectionalLight('dirlight', new BABYLON.Vector3(-1, -2, -1), scene);
    dir.position = new BABYLON.Vector3(10, 15, 10);
    dir.intensity = 1.5; // Increased directional light

    // Shadow generator 
    const shadowGen = new BABYLON.ShadowGenerator(2048, dir);
    shadowGen.useBlurExponentialShadowMap = true;
    shadowGen.blurKernel = 32;
    shadowGen.forceBackFacesOnly = true;
    shadowGenRef.current = shadowGen;

    // Additional point lights for better illumination
    const pLight1 = new BABYLON.PointLight('pointlight1', new BABYLON.Vector3(-10, 8, 5), scene);
    pLight1.intensity = 0.8;
    pLight1.diffuse = new BABYLON.Color3(1, 0.9, 0.8);

    const pLight2 = new BABYLON.PointLight('pointlight2', new BABYLON.Vector3(10, 8, 5), scene);
    pLight2.intensity = 0.8;
    pLight2.diffuse = new BABYLON.Color3(1, 0.9, 0.8);

    // Front light to illuminate the models
    const frontLight = new BABYLON.PointLight('frontlight', new BABYLON.Vector3(0, 5, 15), scene);
    frontLight.intensity = 1.0;
    frontLight.diffuse = new BABYLON.Color3(1, 1, 1);

    // Ground
    const ground = BABYLON.MeshBuilder.CreateGround('ground', { width: 50, height: 50 }, scene);
    ground.position.y = -2;
    const groundMat = new BABYLON.StandardMaterial('groundMat', scene);
    groundMat.diffuseColor = new BABYLON.Color3(0.545, 0.271, 0.075); // brown
    ground.material = groundMat;
    ground.receiveShadows = true;

    // Walls
    const wallMat = new BABYLON.StandardMaterial('wallMat', scene);
    wallMat.diffuseColor = new BABYLON.Color3(0.396, 0.259, 0.129);
    const createWall = (w, h, d, pos) => {
      const wall = BABYLON.MeshBuilder.CreateBox(`wall_${pos.x}_${pos.z}`, { width: w, height: h, depth: d }, scene);
      wall.position = pos;
      wall.material = wallMat;
      wall.receiveShadows = true;
      return wall;
    };
    createWall(50, 10, 1, new BABYLON.Vector3(0, 5, -25));
    createWall(50, 10, 1, new BABYLON.Vector3(0, 5, 25));
    createWall(1, 10, 50, new BABYLON.Vector3(-25, 5, 0));
    createWall(1, 10, 50, new BABYLON.Vector3(25, 5, 0));

    // Helper to import a GLB and return a single parent TransformNode
    const importCock = async (filename, positionVec, rotationY = 0) => {
      try {
        const result = await BABYLON.SceneLoader.ImportMeshAsync('', '/3d/', filename, scene);
        // Create a parent node to control position/rotation/scaling
        const parent = new BABYLON.TransformNode(filename + '_root', scene);

        // Re-parent top-level meshes under the parent (keeps their internal hierarchy)
        result.meshes.forEach((m) => {
          // skip cameras/lights
          if (m instanceof BABYLON.Mesh || m instanceof BABYLON.TransformNode) {
            if (!m.parent) {
              m.parent = parent;
            }
          }
        });

        parent.position = positionVec.clone ? positionVec.clone() : new BABYLON.Vector3(positionVec.x ?? positionVec[0], positionVec.y ?? positionVec[1], positionVec.z ?? positionVec[2]);
        parent.rotation = new BABYLON.Vector3(0, rotationY, 0);
        parent.scaling = new BABYLON.Vector3(3, 3, 3); // Reduced scaling for better visibility

        // Ensure models are positioned above ground
        parent.position.y = 1;

        // Add all real meshes to shadow casters list
        result.meshes.forEach((m) => {
          if (m instanceof BABYLON.Mesh) {
            try { shadowGen.addShadowCaster(m, true); } catch (e) { /* ignore */ }
          }
        });

        return parent;
      } catch (err) {
        console.warn('Import failed for', filename, err);
        return null;
      }
    };

    // Fallback coq creation - More visible and rooster-like
    const createFallbackCock = (name, x) => {
      // Create a parent node for the fallback rooster
      const parent = new BABYLON.TransformNode(name + '_fallback_root', scene);
      
      // Body
      const body = BABYLON.MeshBuilder.CreateCylinder(name + '_body', { height: 3, diameterTop: 1.5, diameterBottom: 2, tessellation: 8 }, scene);
      body.position.set(0, 1.5, 0);
      body.parent = parent;
      
      // Head
      const head = BABYLON.MeshBuilder.CreateSphere(name + '_head', { diameter: 1.2 }, scene);
      head.position.set(0, 3.5, 0.5);
      head.parent = parent;
      
      // Beak
      const beak = BABYLON.MeshBuilder.CreateCylinder(name + '_beak', { height: 0.5, diameterTop: 0.1, diameterBottom: 0.3, tessellation: 6 }, scene);
      beak.position.set(0, 3.5, 1.2);
      beak.rotation.x = Math.PI / 2;
      beak.parent = parent;
      
      // Tail
      const tail = BABYLON.MeshBuilder.CreateCylinder(name + '_tail', { height: 2, diameterTop: 0.3, diameterBottom: 0.8, tessellation: 6 }, scene);
      tail.position.set(0, 2.5, -1.5);
      tail.rotation.x = Math.PI / 4;
      tail.parent = parent;
      
      // Material
      const mat = new BABYLON.StandardMaterial(name + '_mat', scene);
      mat.diffuseColor = new BABYLON.Color3(0.8, 0.4, 0.2); // Brown rooster color
      mat.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1);
      
      // Apply material to all parts
      [body, head, beak, tail].forEach(mesh => {
        mesh.material = mat;
        try { shadowGen.addShadowCaster(mesh, true); } catch (e) {}
      });
      
      // Position the parent
      parent.position.set(x, 1, 0);
      parent.scaling = new BABYLON.Vector3(1.5, 1.5, 1.5);
      
      console.log(`Created fallback rooster: ${name} at position (${x}, 1, 0)`);
      return parent;
    };

    // Base X positions - Closer to center for better visibility
    const COCK1_BASE_X = -8;
    const COCK2_BASE_X = 8;

    // Load both models and fallback if necessary
    (async () => {
      console.log('🐓 Starting to load 3D models...');
      
      const c1 = await importCock('handpainted_rooster.glb', new BABYLON.Vector3(COCK1_BASE_X, 0,0 ), 0);
      if (c1) {
        cock1Ref.current = c1;
        console.log('✅ Cock 1 (handpainted_rooster.glb) loaded successfully');
      } else {
        cock1Ref.current = createFallbackCock('cock1_fallback', COCK1_BASE_X);
        console.log('⚠️ Cock 1 fallback created');
      }

      const c2 = await importCock('rooster_foot_soldier.glb', new BABYLON.Vector3(COCK2_BASE_X, 0, 0), Math.PI);
      if (c2) {
        cock2Ref.current = c2;
        console.log('✅ Cock 2 (rooster_foot_soldier.glb) loaded successfully');
      } else {
        cock2Ref.current = createFallbackCock('cock2_fallback', COCK2_BASE_X);
        console.log('⚠️ Cock 2 fallback created');
      }
      
      console.log('🎮 3D scene setup complete');
    })();

    // Register before render - this replaces requestAnimationFrame loop from Three.js
    scene.registerBeforeRender(() => {
      const now = performance.now();

      // Smooth movement toward target X (attack oscillation or resting)
      if (cock1Ref.current) {
        const targetX = isAttacking1Ref.current ? COCK1_BASE_X + Math.sin(now * 0.008) * 2 : COCK1_BASE_X;
        cock1Ref.current.position.x += (targetX - cock1Ref.current.position.x) * 0.2; // lerp
      }
      if (cock2Ref.current) {
        const targetX = isAttacking2Ref.current ? COCK2_BASE_X + Math.sin(now * 0.008) * 2 : COCK2_BASE_X;
        cock2Ref.current.position.x += (targetX - cock2Ref.current.position.x) * 0.2;
      }
    });

    // Render loop
    engine.runRenderLoop(() => {
      if (scene && !scene.isDisposed) scene.render();
    });

    // Handle resize
    const onResize = () => { try { engine.resize(); } catch (e) {} };
    window.addEventListener('resize', onResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', onResize);
      try {
        scene.dispose();
      } catch (e) {}
      try { engine.dispose(); } catch (e) {}
      engineRef.current = null;
      sceneRef.current = null;
      cock1Ref.current = null;
      cock2Ref.current = null;
      shadowGenRef.current = null;
    };
  }, []);

  // Combat aléatoire 
  useEffect(() => {
    if (gameState.status === 'active') {
      const interval = setInterval(() => {
        if (Math.random() > 0.7) {
          setIsAttacking1(true);
          setTimeout(() => setIsAttacking1(false), 200);
        }
        if (Math.random() > 0.7) {
          setIsAttacking2(true);
          setTimeout(() => setIsAttacking2(false), 200);
        }

        if (Math.random() > 0.8) {
          setIsDefending1(true);
          setTimeout(() => setIsDefending1(false), 300);
        }
        if (Math.random() > 0.8) {
          setIsDefending2(true);
          setTimeout(() => setIsDefending2(false), 300);
        }

        // Réduction de la santé 
        if (Math.random() > 0.9) {
          setCock1Health(prev => Math.max(0, prev - Math.random() * 10));
        }
        if (Math.random() > 0.9) {
          setCock2Health(prev => Math.max(0, prev - Math.random() * 10));
        }
      }, 100);

      return () => clearInterval(interval);
    }
  }, [gameState.status]);

  // Déterminer le gagnant lorsque la partie se termine
  useEffect(() => {
    if (gameState.status === 'finished' && !winner) {
      const winningCock = cock1Health > cock2Health ? 'cock1' : 'cock2';
      setWinner(winningCock);
      if (onCockWin) onCockWin(winningCock);
    }
  }, [gameState.status, cock1Health, cock2Health, winner, onCockWin]);



  return (
  <div className="cock-fight-3d-container" style={{ width: '100%', height: '380px', position: 'relative' }}>
      {/* Montant en haut à droite */}
      <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 20, background: 'rgba(255,255,255,0.85)', borderRadius: '12px', padding: '4px 6px', boxShadow: '0 2px 8px rgba(0,0,0,0.10)' }}>
        {user && <Coin amount={parseFloat(user.balance || 0).toFixed(2)} />}
      </div>



      {/* Nombre de joueurs ayant misé en bas à gauche */}
  <div className="flex items-center text-white text-xs sm:text-sm" style={{ position: 'absolute', bottom: '12px', left: '12px', zIndex: 20 }}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a4 4 0 00-3-3.87M9 20h6M3 20h5v-2a4 4 0 00-3-3.87M16 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
        <span>{gameState.players ? gameState.players.filter(p => p.bet).length : 0} joueurs</span>
      </div>
      <canvas
        ref={canvasRef}
        style={{
          width: '100%',
          height: '100%',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
        }}
      />

      {/* UI overlay — identique à ta version initiale */}
      <div className="cock-fight-overlay" style={{
        position: 'absolute',
        top: '10px',
        left: '10px',
        right: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        pointerEvents: 'none'
      }}>
        {/* Barres de vie supprimées */}
      </div>

      <div
        className="multiplier-time px-2 py-1 sm:px-4 sm:py-2 md:px-6 md:py-3 rounded-md sm:rounded-lg md:rounded-xl"
        // style={{
        //   position: 'absolute',
        //   bottom: '12px',
        //   right: '12px',
        //   background: 'rgba(0,0,0,0.9)',
        //   color: 'white',
        //   fontSize: '16px',
        //   fontWeight: 'bold',
        //   backdropFilter: 'blur(15px)',
        //   border: '2px solid rgba(255, 215, 0, 0.7)',
        //   textAlign: 'center',
        //   minWidth: '64px',
        //   boxShadow: '0 5px 20px rgba(255, 215, 0, 0.3)',
        //   zIndex: 1000
        // }}
      >
        <div
          className="text-xs sm:text-base md:text-lg lg:text-2xl xl:text-3xl"
          style={{
            fontSize: undefined, // Tailwind gère la taille
            color: '#FFD700',
            marginBottom: '5px',
            textShadow: '0 0 10px rgba(255, 215, 0, 0.6)',
            fontWeight: '800',
          }}
        >
          {gameState.multiplier ? `${gameState.multiplier.toFixed(2)}x` : '1.00x'}
        </div>
        <div style={{ fontSize: '12px', color: '#FFF', fontWeight: '500', textShadow: '0 0 5px rgba(255, 255, 255, 0.3)' }}>
          {gameState.status === 'waiting' && gameState.timeLeft ? `⏰ ${Math.ceil(gameState.timeLeft / 1000)}s` : gameState.status === 'active' ? '⚔️ COMBAT!' : gameState.status === 'finished' ? '🏆 TERMINÉ' : '⏳ PRÉPARATION...'}
        </div>
      </div>

      {/* Popup pour partie terminée */}
      {/*
      {gameState.status === 'finished' && (
        <div className="fade-message show bg-red-700 text-white" style={{position: 'absolute', top: 30, left: '50%', transform: 'translateX(-50%)', zIndex: 50, fontSize: '1.1rem', fontWeight: 'bold', padding: '0.5rem 1.5rem', borderRadius: '0.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.15)'}}>
          Partie terminée à {gameState.multiplier ? gameState.multiplier.toFixed(2) : ''}x
        </div>
      )}
      */}


    </div>
  );
};

export default CockFight3D;